let nextId = 0

const state = {
  toasts: []
}

const mutations = {
  ADD_TOAST (state, toast) {
    state.toasts.push(toast)
  },
  REMOVE_TOAST (state, id) {
    state.toasts = state.toasts.filter(t => t.id !== id)
  }
}

const actions = {
  SHOW_TOAST ({ commit }, { message, type = 'success', duration }) {
    if (duration == null) duration = type === 'error' ? 5000 : 3000
    const id = nextId++
    commit('ADD_TOAST', { id, message, type, duration })
    setTimeout(() => {
      commit('REMOVE_TOAST', id)
    }, duration)
  },
  DISMISS_TOAST ({ commit }, id) {
    commit('REMOVE_TOAST', id)
  }
}

export default {
  state,
  mutations,
  actions
}
